import React,{useState, useEffect, Component} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import axios from 'axios';



const RegistroPaciente = () => {

    const baseUrl="http://localhost/";

    const [data, setData]=useState([]);
    const [modalInsertar, setModalInsertar]=useState(true);

    const [pacienteSeleccionado, setinsertPaciente]= useState({
        id:'',
        nombre:'',
        Apellido:'',    
        DNI:'',
        tipoOperador:'',
        sexo:'',
        fechaNacimiento:'',
        email:'',
        telefono:'',
        user:'',
        pass:'',
        telefono:''
    });

    const handleChange=e=>{
        const {name,value}=e.target;
        setinsertPaciente((prevestate)=>({
            ...prevestate,
            [name]: value
        }))
        console.log(pacienteSeleccionado);
    }

    const abrirModalInsertar=()=>{
        setModalInsertar(!modalInsertar);
    }

    const peticionPost=async()=>{
        var f = new FormData();
        f.append("nombre", pacienteSeleccionado.nombre);
        f.append("apellido", pacienteSeleccionado.Apellido);
        f.append("numeroIdentificacion", pacienteSeleccionado.DNI);
        f.append("TipoOperador", pacienteSeleccionado.tipoOperador);
        f.append("sexo", pacienteSeleccionado.sexo);
        f.append("fechaNacimiento", pacienteSeleccionado.fechaNacimiento);
        f.append("email", pacienteSeleccionado.email);
        f.append("telefono", pacienteSeleccionado.telefono);
        f.append("user", pacienteSeleccionado.user);
        f.append("password", pacienteSeleccionado.pass);
        f.append("METHOD", "POST");
        await axios.post(baseUrl,f)
        .then(response=>{
            setData(data.concat(response.data));
            abrirModalInsertar();
       }).catch(error=>{
        console.log(error);
    })
    }

    return (
       

            <Modal isOpen={modalInsertar}>
                    <ModalHeader>Insertar Tipo Usuario</ModalHeader>
                    <ModalBody>
                        <div className="form-group">
                        <label>Nombre: </label>
                        <input type="text" className="form-control" name="nombre" onChange={handleChange}/>
                        <label>Apellido: </label>
                        <input type="text" className="form-control" name="Apellido" onChange={handleChange}/>
                        <label>DNI </label>
                        <input type="text" className="form-control" name="DNI" onChange={handleChange}/>
                       
                        <label >Sexo</label>
                            <select className="form-control" id="sexoselect" name="sexo" onChange={handleChange} >
                                <option>Masculino</option>
                                <option>Femenino</option>
                                <option>Sin Declarar</option>
                        </select>
                        <label >Tipo Usuario</label>
                            <select className="form-control" id="usuarioSelect" name="tipoUsuario" onChange={handleChange}>
                                <option>Paciente</option>
                                <option>Derivante</option>
                        </select>
           
                        <label >Fecha Nacimiento</label>
                        <input className="form-control" type="date"  name="fechaNacimiento" onChange={handleChange} ></input>

                       <label>Email</label>
                        <input className="form-control" type="email" name="email" onChange={handleChange}></input>

                        <label >Telefono</label>
                        <input className="form-control" type="tel" name="telefono" onChange={handleChange}></input>
                   </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-primary" onClick={()=>peticionPost()}>Insertar</button>{"   "}
                        <button className="btn btn-danger" onClick={abrirModalInsertar}>Cancelar</button>
                      
                    </ModalFooter>
            </Modal>
    )

}
export default RegistroPaciente;